import './styles/global.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { NavigationProvider } from './context/navigation';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <NavigationProvider>
        <App />
    </NavigationProvider>
);
